import React, { useState, useEffect } from 'react';
import './Header.css';
import { Link } from 'react-router-dom';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeLink, setActiveLink] = useState('');

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);

    if (!menuOpen) {
      document.body.classList.add('menu-open');
    } else {
      document.body.classList.remove('menu-open');
    }
  };

  // Close/open menu only on mobile
  const handleMobileClick = () => {
    if (window.innerWidth <= 1363) {
      toggleMenu();
    }
  };

  // Scroll-based active link (like KPMG)
  useEffect(() => {
    const handleScroll = () => {
      const sections = [
        { id: 'about', key: 'about' },
        { id: 'services', key: 'services' },
        { id: 'portfolio', key: 'portfolio' },
        { id: 'projects', key: 'projects' },
        { id: 'finance-magazine', key: 'magazine' },
        { id: 'contact', key: 'contact' },
      ];

      const scrollPosition = window.scrollY + 140; // offset for fixed header

      let current = '';

      sections.forEach((section) => {
        const el = document.getElementById(section.id);
        if (!el) return;

        const top = el.offsetTop;
        const height = el.offsetHeight;

        if (scrollPosition >= top && scrollPosition < top + height) {
          current = section.key;
        }
      });

      setActiveLink(current);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // run once on load

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* DARK OVERLAY */}
      <div
        className={`mobile-shadow ${menuOpen ? 'show' : ''}`}
        onClick={toggleMenu}
      ></div>

      <header role="banner" className="site-header">
        <div className="header-inner">

          {/* LOGO */}
          <div className="logo">
            <Link
              to="/"
              onClick={() => {
                setActiveLink('');
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
            >
              <img
                src="/assets/logo.png"
                alt="Abdulrahman Alamoudi personal logo"
                width="150"
              />
            </Link>
          </div>

          {/* CIRCLE HAMBURGER */}
          <div
            className={`hamburger ${menuOpen ? 'open' : ''}`}
            onClick={toggleMenu}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>

          {/* NAV */}
          <nav className={`site-nav ${menuOpen ? 'open' : ''}`}>
            <a
              href="/#about"
              className={activeLink === 'about' ? 'active' : ''}
              onClick={() => { setActiveLink('about'); handleMobileClick(); }}
            >
              About
            </a>
            <a
              href="/#services"
              className={activeLink === 'services' ? 'active' : ''}
              onClick={() => { setActiveLink('services'); handleMobileClick(); }}
            >
              Expertise
            </a>
            <a
              href="/#portfolio"
              className={activeLink === 'portfolio' ? 'active' : ''}
              onClick={() => { setActiveLink('portfolio'); handleMobileClick(); }}
            >
              Certifications
            </a>
            <a
              href="/#projects"
              className={activeLink === 'projects' ? 'active' : ''}
              onClick={() => { setActiveLink('projects'); handleMobileClick(); }}
            >
              Projects
            </a>
            <a
              href="/#finance-magazine"
              className={activeLink === 'magazine' ? 'active' : ''}
              onClick={() => { setActiveLink('magazine'); handleMobileClick(); }}
            >
              Magazine
            </a>
            <a
              href="/#contact"
              className={activeLink === 'contact' ? 'active' : ''}
              onClick={() => { setActiveLink('contact'); handleMobileClick(); }}
            >
              Connect
            </a>
            <Link
              to="/resume"
              className={activeLink === 'resume' ? 'active' : ''}
              onClick={() => {
                setActiveLink('resume');
                handleMobileClick();
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
            >
              Resume
            </Link>

          </nav>

        </div>
      </header>
    </>
  );
}

export default Header;
